/**
 * EmailTemplatesPage — `/admin/email-templates`.
 *
 * Legacy admin entry point that previously rendered a read-only catalogue of
 * notification templates. The settings surface
 * (`/settings/notification-templates`) already covers EMAIL / SMS / PUSH with
 * an inline editor wired to `updateNotificationTemplate`, so this route now
 * redirects there with `?channel=EMAIL` so the editable email tab is preselected.
 *
 * The route + sidebar entry are kept so existing deep-links and bookmarks
 * continue to land somewhere sensible.
 */
import type { JSX } from 'react';
import { Navigate } from 'react-router-dom';

export function EmailTemplatesPage(): JSX.Element {
  return <Navigate to="/settings/notification-templates?channel=EMAIL" replace />;
}
